module.exports = __webpack_public_path__ + "img/09.80c2b167.png";